<template>
    <div class="context">
        <div v-if="showText" class="text main">
            <div class="box" @click="edit">
                <div class="title">
                    <span>{{form.number}}. {{form.title}}</span>
                    <span v-if="form.required == 2" class="color_red">*</span>
                </div>
                <div class="des">
                    {{form.description}}
                </div>
                <div class="input">
                    <el-date-picker
                            :disabled="!disabled"
                            v-model="value"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                    </el-date-picker>
                </div>

                <div class="right_btn" v-if="!disabled">
                    <div class="icon" @click.stop="edit">
                        <span class="iconfont icon-xiugai"></span>
                    </div>
                    <div class="icon" @click.stop="delDes">
                        <span class="iconfont icon-shanchu1"></span>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="form main">
            <div class="box">
                <el-form :model="form"
                         :rules="rules"
                         ref="form"
                         size="small"
                         label-width="60px">
                    <el-form-item label="题目" prop="title">
                        <el-input class="width_all_100" v-model="form.title"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input class="width_all_100" v-model="form.description"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="checked">必填</el-checkbox>
                    </el-form-item>
                    <el-form-item align="right">
                        <el-button @click="cancel">取消</el-button>
                        <el-button @click="submit" type="primary">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="left_question_type">时间</div>
    </div>
</template>

<script>
    import {questionMixin} from "./common/com";
    export default {
        name: "time_v",
        mixins: [questionMixin],
    }
</script>

<style scoped lang="scss">
    @import "common/com.scss";
</style>